<button nz-button nzSize="large" [nzBlock]="fullSize" (click)="isVisible = true">
  <i nz-icon nzType="history" nzTheme="outline"></i>
  <span *ngIf="fullSize">
    {{ 'LOT_EVENTS.TITLE' | translate }}
  </span>
</button>

<nz-modal
  [nzWidth]="1000"
  [(nzVisible)]="isVisible"
  [nzTitle]="'LOT_EVENTS.TITLE' | translate"
  [nzContent]="content"
  [nzFooter]="footer"
  (nzOnCancel)="isVisible = false"
>
  <ng-template #content>
    <nz-tabset nzSize="small">
      <nz-tab [nzTitle]="'LOT_EVENTS.HISTORY.TITLE' | translate">
        <app-lot-history [lot]="lot"></app-lot-history>
      </nz-tab>

      <nz-tab [nzTitle]="'LOT_EVENTS.VIEWS.TITLE' | translate">
        <app-lot-views [lot]="lot"></app-lot-views>
      </nz-tab>
    </nz-tabset>
  </ng-template>

  <ng-template #footer>
    <button nz-button (click)="isVisible = false">
      {{ 'CANCEL' | translate }}
    </button>
  </ng-template>
</nz-modal>
